module.exports = __webpack_public_path__ + "static/media/AbdulRasheed.7b153132.jpeg";